// Import
import React from "react";
import styled from "styled-components";
import styles from "./RowText_styles";
import { formatNumber } from "../../helpers/formatNumber";
import {formatDateShort} from "../../helpers/formatDate";

/***
 * PROPS
 * username:String = Set Username on item
 * debt:String Set debt on Saldo
 *
 */

// Componente base
const RowText_base = ({
  mostrarSaldo = false,
  handleClickDetalle,
  username,
  debt,
  fechaCreacionCredito,
  fechaCuotaCredito,
  prestado,
  montoAdelantado,
  montoVencido,
  enrutar = null,
  ...props
}) => {
  let moraLabel = "";
  let aldiaFormatted = "";

  if (montoAdelantado > 0) {
      moraLabel = "Adelantado";
      aldiaFormatted = formatNumber(montoAdelantado);
  } else if (montoVencido > 0) {
    moraLabel = "Mora";
    aldiaFormatted = formatNumber(montoVencido);
  }

  return (
    <div {...props} onClick={handleClickDetalle}>
      <div className="username">{username}</div>
      {debt ? (
        <>
          <div className="debt">
            {mostrarSaldo ? <b>Saldo</b> : ""} {debt}
          </div>

          {moraLabel && (
            <div className="debt">
              <b>{moraLabel}</b> : {aldiaFormatted}
            </div>
          )}

          <div className="debt">
            <b>Prestado</b> : {prestado}
          </div>
          <div className="debt">
            <b>Fecha creación crédito</b> : {formatDateShort(fechaCreacionCredito)}
          </div>
          <div className="debt">
            <b>Fecha cuota</b> : {fechaCuotaCredito}
          </div>
        </>
      ) : null}
      {enrutar ? <div style={{ fontSize: "1.2em" }}>{enrutar}</div> : null}
    </div>
  );
};

const RowText = styled(RowText_base)`
  ${styles}
`;

export default RowText;
